export default __webpack_public_path__ + "static/media/banner8.e46ffc63.png";